/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext } from 'react';
import {ARMcontext} from '../../../../../utils/context/context';
import {
  CardContainer,
  CardDataContainer,
  CardExpiry,
  CardHeader,
  CardHolder,
  CardHolderName,
  CardNumber,
  CardNumberHeader,
  CardOptionsContainer,
  CardWrapper,
  RemoveLabel,
  RadiosContainer,
  CardIconNumber,
} from './styles';
import {Admin} from '../../../../../utils/api';
import {Radio} from '../../../../../components';
import {EditCardModal} from '../../editCardModal/editCardModal';
import {CardType} from '../../../../../utils/hooks/cardType';
export const CardComponent = ({cardInfo, fetchCards}) => {
  const [editCardModal, useEditCardModal] = useState(false);
  const {HandleToastMessage} = useContext(ARMcontext);
  const ADMIN = new Admin();
  async function setAsDefaultCard() {
    const updateCard = await ADMIN.EditCard({id: cardInfo.id, default: true});
    if (updateCard.status) {
      fetchCards();
    }
  }
  function handleEditModal(val) {
    useEditCardModal(val);
  }
  function handleClickOutside(e) {
    if (e.target.id === 'modal') {
      useEditCardModal(false);
    }
  }
  async function removeCard(cardNumber) {
    const response = await ADMIN.DeleteCard({paymentMethodId: cardNumber});
    if (response.status) {
      HandleToastMessage('The card was successfully removed', true, 2500, 'success');
      fetchCards();
    }
  }
  function editCard() {
    useEditCardModal(true);
  }

  const _renderLogoCard = (type: string) => <img src={CardType[type]} alt="" />;

  return (
    <>
      {editCardModal && (
        <div onClick={handleClickOutside}>
          <EditCardModal handleModalFunction={handleEditModal} refreshCards={fetchCards} card={cardInfo} />
        </div>
      )}
      <CardContainer>
        <CardWrapper>
          <CardHeader>
            <CardNumberHeader>
              <CardIconNumber>
                {_renderLogoCard(cardInfo.brand)}
                <CardNumber disabled={true} value={`************${cardInfo?.last4}`} />
              </CardIconNumber>
              <CardExpiry>{`${cardInfo.month}/${cardInfo.year}`}</CardExpiry>
            </CardNumberHeader>
          </CardHeader>
          <CardDataContainer>
            <CardHolder>Card name</CardHolder>
            <CardHolderName>{cardInfo.name}</CardHolderName>
          </CardDataContainer>
        </CardWrapper>
        <CardOptionsContainer>
          <RadiosContainer onChange={() => setAsDefaultCard()}>
            <Radio
              title="Default"
              name={`default${cardInfo.id}`}
              id={cardInfo.id}
              checked={false}
              dynamicActive={cardInfo.default}
              size={'21px'}
            />
          </RadiosContainer>
          <RemoveLabel onClick={() => removeCard(cardInfo.id)} type="remove">
            Remove
          </RemoveLabel>
          <RemoveLabel onClick={() => editCard()}>Edit</RemoveLabel>
        </CardOptionsContainer>
      </CardContainer>
    </>
  );
};
